import React from "react";
import MatchupTeams from "../MatchupTeams";
import TeamPlayerLineup from "../../Team/TeamPlayerLineup";
import { WebSportItem } from "src/constants";

/**
 * Split panel to display player lineups in a matchup
 */
const MatchupTeamsPlayerLineup = ({ event, currentSportObj }: { event: any; currentSportObj: WebSportItem }) => {
  const leageName = (event.league && event.league.name) || "";
  return (
    <MatchupTeams
      event={event}
      panelName="Lineup"
      trackingKey="Lineups"
      currentSportObj={currentSportObj}
      awayTeamContent={<TeamPlayerLineup leagueName={leageName} lineup={event.awayLineup} team={event.awayTeam} />}
      homeTeamContent={<TeamPlayerLineup leagueName={leageName} lineup={event.homeLineup} team={event.homeTeam} />}
    />
  );
};

export default MatchupTeamsPlayerLineup;
